<template>
  <base-card
    v-click-outside="onClickOutside"
    condensed
    class="toolbar-fixes"
  >
    <vue-editor
      :id="'editor-'+uniqid"
      :ref="uniqref"
      v-model="content"
      :editor-options="editorSettings"
      @selection-change="selectionChange"
      @blur="isFocused = false"
      @focus="isFocused = true"
    />
    <div class="toolbar__container">
      <div
        v-if="fontsLoaded"
        :id="`textWidgetToolbar${uniqid}`"
        class="mainToolbar"
      >
        <!-- default at 12pt -->
        <span class="ql-formats">
          <!--<button
            type="button"
            class="ql-image"
          />-->
          <button
            type="button"
            class="ql-link"
          />
          <button
            type="button"
            class="ql-bold"
            @mouseover="onButtonMouseover"
            @mouseout="onButtonMouseout"
          />
          <button
            type="button"
            class="ql-italic"
            @mouseover="onButtonMouseover"
            @mouseout="onButtonMouseout"
          />
          <button
            type="button"
            class="ql-underline"
            @mouseover="onButtonMouseover"
            @mouseout="onButtonMouseout"
          />
        </span>
        <span class="ql-formats">
          <button
            class="ql-align"
            value
          />
          <button
            class="ql-align"
            value="center"
          />
          <button
            class="ql-align"
            value="right"
          />
        </span>
        <span
          :id="`formatsToolbar${uniqid}`"
          class="ql-formats"
        >
          <select class="ql-size">
            <option selected="selected" />
            <option value="small" />
            <option value="large" />
            <option value="huge" />
          </select>
          <select
            :ref="`qlFontSelect${uniqid}`"
            class="ql-font"
          >
            <!-- Only using selected="selected" the fonts change correctly as you move the cursor -->
            <!-- Warning: Note that the first paragraph has
            NO SELECTED FONT by default, so the fonts select stays on the last shown -->
            <option
              v-for="(font, index) in textboxFonts"
              :key="`ql-font-${index}`"
              :value="font.font_family"
            />
          </select>
        </span>
      </div>
    </div>
  </base-card>
</template>
<script>
import VueEditorMixins from '../_utilities/VueEditorMixins';

export default {
  name: 'TextWidget',
  mixins: [VueEditorMixins],
  data() {
    return {
      content: '',
      editorSettings: {
        formats: [
          'background',
          'bold',
          'color',
          'font',
          'code',
          'italic',
          'link',
          'size',
          'strike',
          // 'script',
          'underline',
          'blockquote',
          'header',
          'indent',
          'list',
          'align',
          'direction',
          'code-block',
          'font',
          'hashtag',
          // 'image'
          // 'video'
        ],
        modules: {
          toolbar: {
            container: '',
            handlers: {
              addTag: () => {
                this.addCustomTag('Name');
              },
            },
          },
        },
      },

    };
  },
  watch: {
    isFocused(newVal) {
      if (newVal) {
        this.$store.state.entries.isTextFocused = true;
      }
    },
  },
  created() {
    this.editorSettings.modules.toolbar.container = `#textWidgetToolbar${this.uniqid}`;
  },
  methods: {
    onButtonMouseover() {
      console.log('toolbar mouseOVER');
      this.$store.commit('sections/setDraggable', false);
    },
    onButtonMouseout() {
      console.log('toolbar mouseOUT');
      this.$store.commit('sections/setDraggable', true);
    },
    onClickOutside() {
      this.$nextTick().then(() => {
        if (this.$refs[this.uniqref].quill?.selection?.lastRange === null) {
          this.$store.state.entries.isTextFocused = false;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.ql-image {
  background-image: url("~@/assets/icons/images-row.svg") !important;
  background-size: 70% !important;
}
.ql-attach {
  background-image: url("~@/assets/icons/add-attachment.svg") !important;
}
.ql-link {
  background-image: url("~@/assets/icons/add-link.svg") !important;
}
.ql-bold {
  background-image: url("~@/assets/icons/bold.svg") !important;
  background-size: 11px 14px!important;
}
.ql-italic {
  background-image: url("~@/assets/icons/italic.svg") !important;
  background-size: 9px 15px!important;
}
.ql-underline {
  background-image: url("~@/assets/icons/underline.svg") !important;
  background-size: 12px 15px!important;
}
.ql-align[value=""] {
  background-image: url("~@/assets/icons/align-left.svg") !important;
}
.ql-align[value="center"] {
  background-image: url("~@/assets/icons/align-center.svg") !important;
}
.ql-align[value="right"] {
  background-image: url("~@/assets/icons/align-right.svg") !important;
}
button[class^="ql-"][type="button"]:not(.ql-addTag) {
  background-repeat: no-repeat !important;
  background-color: transparent !important;
  background-attachment: scroll !important;
  background-position: 50% 50% !important;
  text-align: center;
}

button[class^="ql-"] > svg {
    display: none !important;
}

.ql-toolbar {
  position: absolute;
  bottom: 0;
  width: 100%;
  border: 0px !important;
  z-index: 19;
  background-color: $gray-light !important;
  transform: translateY(100%);
  border-radius: 0 0 5px 5px;
}

.quillWrapper {
  position: relative !important;
  margin: 0 -0.625rem -0.625rem -0.625rem;
  border: 0px !important;
}

.toolbar__container {
  position: relative;
  padding-top: 2rem;
  margin: 0 -0.625rem 0 -0.625rem;
  .ql-font {
    & .ql-picker-label,
     .ql-picker-item {
      font-family: $font-family-sans-serif;
    }
    .ql-picker-label {
      border-color: transparent !important;
    }
  }
}
.mainToolbar {
  position: absolute;
  margin: 0;
  transform: translateY(1rem);
}

</style>
<style lang="scss" scoped>
::v-deep button[class^="ql-"][type="button"]:not(.ql-addTag)  {
  margin-right: 4px !important;
  padding-bottom: 24px !important;
  &.ql-active {
    background-color: rgba(black, 0.1) !important;
    border-radius: 4px !important;
  }
}
.toolbar-fixes {
  overflow: hidden;
  margin-bottom: 24px;
  @media (min-width: map-get($breakpoints,'lg')) {
    overflow: visible;
  }
}
</style>
